// src/components/Footer.js
import React from 'react';

export default function Footer() {
  return (
    <footer
      style={{
        padding: '1rem 2rem',
        textAlign: 'center',
        backgroundColor: 'var(--footer-bg, #f3f4f6)', // light gray background
        color: 'var(--footer-text, #6b7280)',          // neutral gray text
        fontSize: '0.9rem',
        fontWeight: '500',
        letterSpacing: '0.05em',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.4)',
        userSelect: 'none',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        transition: 'background-color 0.3s ease',
      }}
    >
      &copy; {new Date().getFullYear()} CloudFactory Ltd
    </footer>
  );
}